export const activityListOption = {
  border: true,
  stripe: true,
  menuAlign: 'center',
  align: 'center',
  searchShow: false,
  searchBtn: false,
  refreshBtn: false,
  columnBtn: false,
  menu: false,
  addBtn: false,
  delBtn: false,
  editBtn: false,
  viewBtn: false,
  searchBtn: false,
  column: [
    {
      label: '区域',
      prop: 'regionName',
      editDisabled: true,
    },
    {
      label: '市场',
      prop: 'marketName',
      editDisabled: true,
    },
    {
      label: '总经理',
      prop: 'gmName',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '营运总监',
      prop: 'doName',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '营运经理',
      prop: 'omName',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '营运顾问',
      prop: 'ocName',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '餐厅国际编号',
      prop: 'storeCode',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '餐厅名称',
      prop: 'storeName',
      editDisabled: true,
      width: '200px',
    },
    {
      label: '员工编号',
      prop: 'unionId',
      editDisabled: true,
      width: '120px',
    },
    {
      label: '员工姓名',
      prop: 'nickName',
      editDisabled: true,
      width: '130px',
    },
    {
      label: '入职时间',
      prop: 'serviceStartDate',
      editDisabled: true,
      width: '100px',
    },
    {
      label: '身份',
      prop: 'identity',
      editDisabled: true,
    },
    {
      label: '职位',
      prop: 'position',
      editDisabled: true,
    },
    {
      label: '职级',
      prop: 'grade',
      editDisabled: true,
    },
    {
      label: '岗位海报',
      prop: 'hasPoster',
      editDisabled: true,
      dicData: [
        { label: '已制作', value: true },
        { label: '未制作', value: false },
      ],
    },
    {
      label: '领取阳光',
      prop: 'hasGotPlanting',
      editDisabled: true,
      dicData: [
        { label: '已领取', value: true },
        { label: '未领取', value: false },
      ],
    },
    {
      label: '播撒阳光',
      prop: 'hasUsedPlanting',
      editDisabled: true,
      dicData: [
        { label: '已播撒', value: true },
        { label: '未播撒', value: false },
      ],
    },
    {
      label: '食品安全认证',
      prop: 'foodSafetyFlag',
      editDisabled: true,
      dicData: [
        { label: '已认证', value: 'Y' },
        { label: '未认证', value: 'N' },
      ],
    },
    {
      label: '3个岗位鉴定',
      prop: 'positionAppraisalFlag',
      editDisabled: true,
      dicData: [
        { label: '已通过', value: 'Y' },
        { label: '未通过', value: 'N' },
      ],
    },
    {
      label: '报名状态',
      prop: 'hasSignedUp',
      editDisabled: true,
      dicData: [
        { label: '已报名', value: true },
        { label: '未报名', value: false },
      ],
    },
    {
      label: '报名岗位数',
      prop: 'signedUpCount',
      editDisabled: true,
    },
    {
      label: '报名岗位1',
      prop: 'signedUpPosition1',
      editDisabled: true,
    },
    {
      label: '队友1',
      prop: 'signedUpPartner1',
      editDisabled: true,
    },
    {
      label: '报名岗位2',
      prop: 'signedUpPosition2',
      editDisabled: true,
    },
    {
      label: '队友2',
      prop: 'signedUpPartner2',
      editDisabled: true,
    },
    {
      label: '报名岗位3',
      prop: 'signedUpPosition3',
      editDisabled: true,
    },
    {
      label: '队友3',
      prop: 'signedUpPartner3',
      editDisabled: true,
    },
    // {
    //   label: 'Patch阶段pk总分',
    //   prop: 'patchScore',
    //   editDisabled: true,
    // },
    // {
    //   label: 'PC阶段pk总分',
    //   prop: 'pcScore',
    //   editDisabled: true,
    // },
    // {
    //   label: 'DO阶段PK总分',
    //   prop: 'doScore',
    //   editDisabled: true,
    // },
    // {
    //   label: 'Patch阶段pk次数',
    //   prop: 'patchTimes',
    //   editDisabled: true,
    // },
    // {
    //   label: 'PC阶段pk次数',
    //   prop: 'pcTimes',
    //   editDisabled: true,
    // },
    // {
    //   label: 'DO阶段PK次数',
    //   prop: 'doTimes',
    //   editDisabled: true,
    // },
    // {
    //   label: 'Patch阶段答题平均时长',
    //   prop: 'patchDuration',
    //   editDisabled: true,
    // },
    // {
    //   label: 'PC阶段答题平均时长',
    //   prop: 'pcDuration',
    //   editDisabled: true,
    // },
    // {
    //   label: 'DO阶段答题平均时长',
    //   prop: 'doDuration',
    //   editDisabled: true,
    // },
  ]
}

export const options = [
  { label: '是', value: true },
  { label: '否', value: false },
]

export const postOptions = [
  { label: '已制作', value: true },
  { label: '未制作', value: false },
]

export const sunshineOptions = [
  { label: '已领取', value: true },
  { label: '未领取', value: false },
]

export const sunshineStatusOptions = [
  { label: '已播撒', value: true },
  { label: '未播撒', value: false },
]

export const signUpOptions = [
  { label: '已报名', value: true },
  { label: '未报名', value: false },
]

export const foodSafetyOptions = [
  { label: '已认证', value: 'Y' },
  { label: '未认证', value: 'N' },
]

export const positionAppraisalOptions = [
  { label: '已通过', value: 'Y' },
  { label: '未通过', value: 'N' },
]

export const identityOptions = [
  { label: '全职', value: '全职' },
  { label: '兼职人员', value: '兼职人员' },
  { label: '协保', value: '协保' },
  { label: '学生', value: '学生' },
  { label: '实习生', value: '实习生' },
  { label: '派遣', value: '派遣' },
  { label: '退休', value: '退休' },
  { label: '非全', value: '非全' },
]

export const gradeOptions = [
  { label: '.Crew-1.', value: '.Crew-1.' },
  { label: '.Crew-2.', value: '.Crew-2.' },
  { label: '.Crew-3.', value: '.Crew-3.' },
  { label: '.Crew-A1.', value: '.Crew-A1.' },
  { label: '.Crew-A2.', value: '.Crew-A2.' },
  { label: '.Crew-Barista.', value: '.Crew-Barista.' },
  { label: '.Crew-Barista Trainee.', value: '.Crew-Barista Trainee.' },
  { label: '.Crew-Chief GEL.', value: '.Crew-Chief GEL.' },
  { label: '.Crew-CMIP.', value: '.Crew-CMIP.' },
  { label: '.Crew-Crew.', value: '.Crew-Crew.' },
  { label: '.Crew-Crew Trainer.', value: '.Crew-Crew Trainer.' },
  { label: '.Crew-GEL.', value: '.Crew-GEL.' },
  { label: '.Crew-Senior Barista.', value: '.Crew-Senior Barista.' },
  { label: '.Crew-Senior GEL.', value: '.Crew-Senior GEL.' },
  { label: '.Crew-Shift Swing.', value: '.Crew-Shift Swing.' },
  { label: '.Crew-Swing Manager.', value: '.Crew-Swing Manager.' },
]
